/** The reactions a feed item, thread or comment can carry, as they read. */
export const REACTION_EMOJI = {
  thumbs_up: "👍",
  heart: "❤️",
  laugh: "😂",
  celebrate: "🎉",
  eyes: "👀",
  check: "✅",
} as const;
